import { FaqComponent } from './pages/dashboard/faq/faq.component';
import { ClientOnboardingComponent } from './pages/dashboard/client-onboarding/client-onboarding.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessGuard } from './guard/access.guard';
import { ExitGameService } from './guard/exit-game.service';
import { LoginGuard } from './guard/login.guard';
import { ActivityLogComponent } from './pages/dashboard/activity-log/activity-log.component';
import { AnalyticsComponent } from './pages/dashboard/analytics/analytics.component';
import { ChatbotFlowComponent } from './pages/dashboard/chatbot-flow/chatbot-flow.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { GameMenuComponent } from './pages/dashboard/games/game-menu/game-menu.component';
import { GamesComponent } from './pages/dashboard/games/games.component';
import { PlayComponent } from './pages/dashboard/games/play/play.component';
import { MicroLearningContentComponent } from './pages/dashboard/micro-learning-content/micro-learning-content.component';
import { ReportsComponent } from './pages/dashboard/reports/reports.component';
import { ShipActivityComponent } from './pages/dashboard/ship-activity/ship-activity.component';
import { UserActivityComponent } from './pages/dashboard/user-activity/user-activity.component';
import { LoginComponent } from './pages/login/login.component';
import { ChartsComponent } from './pages/dashboard/charts/charts.component';
import { ZohoLinksComponent } from './pages/dashboard/zoho-links/zoho-links.component';
import { SynopsisComponent } from './pages/dashboard/synopsis/synopsis.component';
import { OshComponent } from './pages/dashboard/osh/osh.component';
import { GamesExcelComponent } from './pages/dashboard/games-excel/games-excel.component';
import { DocumentarchivesComponent } from './pages/dashboard/documentarchives/documentarchives.component';
import { UploaddocumentComponent } from './pages/dashboard/documentarchives/uploaddocument/uploaddocument.component'
import { DocumentpageComponent } from './pages/dashboard/documentarchives/documentpage/documentpage.component';
import { VideoLibraryUploadComponent } from './pages/dashboard/video-library-upload/video-library-upload.component';
import { PemeContentComponent } from './pages/dashboard/peme-content/peme-content.component';
import { PemeCheckinsComponent } from './pages/dashboard/peme-checkins/peme-checkins.component';
import { PemeDailyTaskComponent } from './pages/dashboard/peme-daily-task/peme-daily-task.component';
const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: 'chatbotjsonexcel',
        component: ChatbotFlowComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'microlearningjsonexcel',
        component: MicroLearningContentComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'mindbodysouljsonexcel',
        component: MicroLearningContentComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'activitylog',
        component: ActivityLogComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'documentarchives',
        component: DocumentarchivesComponent,
        children: [
          { path: '', component: DocumentpageComponent },
          {
            path: 'uploaddocument',
            component: UploaddocumentComponent,
          },
        ],
      },
      {
        path: 'useractivity',
        component: UserActivityComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'shipactivity',
        component: ShipActivityComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'games',
        component: GamesComponent,
        canActivate: [AccessGuard],
        children: [
          { path: '', component: GameMenuComponent },
          {
            path: 'play',
            component: PlayComponent,
            canDeactivate: [ExitGameService],
            canActivate: [AccessGuard],
          },
          { path: '**', component: GameMenuComponent },
        ],
      },
      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [AccessGuard],
        children: [
          {
            path: 'leaderboard',
            component: ReportsComponent,
            canActivate: [AccessGuard],
          },
          {
            path: 'leaderboardmaritime',
            component: ReportsComponent,
            canActivate: [AccessGuard],
          },
          {
            path: 'synopsis',
            component: SynopsisComponent,
            canActivate: [AccessGuard],
          },
        ],
      },
      {
        path: 'faqfromhtml',
        component: FaqComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'clientonboarding',
        component: ClientOnboardingComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'charts',
        component: ChartsComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'analytics',
        component: AnalyticsComponent,
      },
      {
        path: 'zohoLinks',
        component: ZohoLinksComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'oshexcel',
        component: OshComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'gameexcel',
        component: GamesExcelComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'factoidexcel',
        component: MicroLearningContentComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'videolibrary',
        component: VideoLibraryUploadComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'pemecontent',
        component: PemeContentComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'pemecheckins',
        component: PemeCheckinsComponent,
        canActivate: [AccessGuard],
      },
      {
        path: 'pemedailytask',
        component: PemeDailyTaskComponent,
        canActivate: [AccessGuard],
      },
      { path: '', redirectTo: '/dashboard/analytics', pathMatch: 'full' },
      { path: '**', redirectTo: '/dashboard/analytics', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '/dashboard/analytics', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
